module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c41dc2ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Xero/XeroCallBackAuth.vue
// module id = 2286
// module chunks = 0